import { useState } from 'preact/hooks';
import { get, post } from '../api';
import { Button, Card, Empty, Field, Link, Loading, Pill, navigate, timeAgo, useAction, useLoad } from '../ui';

export function Stories() {
	const list = useLoad(() => get('/api/stories'));
	const [title, setTitle] = useState('');
	const [create, busy] = useAction(async () => {
		const r = await post('/api/stories', { title: title || 'Untitled story', source: '' });
		navigate(`/stories/${r.id}`);
	});
	return (
		<main class="page">
			<h1>Stories</h1>
			<div class="two-col">
				<Card title="New story">
					<p>Write your story as prose. The compiler works out where it takes place and how the characters move from place to place, and draws it as a location map.</p>
					<Field label="Title">
						<input value={title} onInput={(e) => setTitle(e.currentTarget.value)} />
					</Field>
					<Button onClick={() => create()} busy={busy}>
						Start writing
					</Button>
				</Card>
				<Card title="Your stories">
					{!list.data ? (
						<Loading />
					) : list.data.stories.length ? (
						<ul class="list">
							{list.data.stories.map((s: any) => (
								<li key={s.id} class="row-between">
									<span>
										<Link href={`/stories/${s.id}`}>{s.title}</Link>
									</span>
									<span>
										<Pill tone={s.status === 'compiled' ? 'ok' : s.status.startsWith('compiling') ? 'accent' : s.status === 'failed' ? 'bad' : 'muted'}>{s.status}</Pill>{' '}
										<span class="small muted">{timeAgo(s.updated_at)}</span>
									</span>
								</li>
							))}
						</ul>
					) : (
						<Empty>No stories yet.</Empty>
					)}
				</Card>
			</div>
		</main>
	);
}
